var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v(" 高考报考之窗是一家专注于高考志愿填报的大数据平台，为每年百万高考生提供在线职业规划测评、学业规划测评、学习状态测评、高考志愿填报一对一咨询、新高考选科一对一咨询、自主招生、港澳台院校申请服务。 ")])])])
}]

export { render, staticRenderFns }